import React from 'react';
import Appbar from './appbar';
import Menu from './menu';
import ServiceMessages from '../../services/messages';

import UserService from "../../services/users";
class MenuLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false ,unread:0};


    }

     checkMessages = () =>{
        ServiceMessages.get().then(
            messages => {
                const currentUser = UserService.currentUser();
             let count = messages.filter(message => { return message.read.indexOf(currentUser._id) ==-1 }).length;
                this.setState({ unread: count });
            },
            error => {
              console.log("error", error);
            }
          );

    }
    handleOpen = (value) => {
        this.checkMessages();
        this.setState({ open: value });
    }

    componentDidMount() {
   
        this.checkMessages();
    }

    render() {
        return (
            <div>
                {
                    !this.props.menu.hide &&
                    <React.Fragment>
                        <Appbar {...this.props} onMenuClick={() => this.setState({ open: true })}></Appbar>
                        <Menu {...this.props} open={this.state.open} handleOpen={this.handleOpen} unread={this.state.unread}></Menu>
                    </React.Fragment>
                }
               <div className="padding-ios" style={{marginTop:'55px'}}>{this.props.children}</div> 
            </div>
        )
    }
}
export default MenuLayout;